import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IShoppingBasketItem } from 'models/cart/shoppingbasketitem';
import { PortalPageSection } from 'components/PortalStructure';

require('./style.css');

interface IProps {
	items?: IShoppingBasketItem[];

	/* function props */
	removeShoppingBasketItem?: (productId: string) => void;
	t?: (key: string) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShoppingBagRemovedItems extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	/** --------------RENDER ----------------------- */
	public render() {
		const { t, items } = this.props;

		if (!items || (items && items.length === 0)) {
			return null;
		}

		return (
			<div className="shoppingBagRemovedItems">
				<PortalPageSection>
					{items.map((item) => (
						<div key={item.productId}>
							<div className="wrapperTextLeft">
								<div className="defaultText">
									<img src={require('containers/Html/images/productnoimage.svg')} />
								</div>
							</div>
							<div className="rightText">
								<div className="productName">{item.productName}</div>
								<div className="wrapperErrorMessage">
									<span className="errorMessage">{t('ShoppingBagRemovedProductCard_RemovedProductMessage')}</span>
								</div>
							</div>
							{this.props.removeShoppingBasketItem ? (
								<div className="wrapperDeleteBtn">
									<button
										type="button"
										onClick={() => {
											this.props.removeShoppingBasketItem(item.productId);
										}}
									>
										<img src={require('containers/Html/icons/actionIcons/remove.svg')} />
									</button>
								</div>
							) : null}
						</div>
					))}
				</PortalPageSection>
			</div>
		);
	}
}

export { ShoppingBagRemovedItems };
